import React, { useState } from 'react';
import SmsKpis from './SmsKpis';
import SmsMasivo from './SmsMasivo';

/**
 * La sección de SMS, partida en dos como Llamadas: **Panel** (qué está pasando
 * con el canal) y **Envío masivo** (mandar un SMS a un grupo de expedientes).
 */

const TABS = [
  { key: 'panel', label: 'Panel' },
  { key: 'masivo', label: 'Envío masivo' },
];

const SmsSettings = () => {
  const [tab, setTab] = useState('panel');

  return (
    <div className='space-y-4'>
      <div className='flex gap-1 rounded-lg border border-slate-200 bg-white p-1'>
        {TABS.map(({ key, label }) => (
          <button
            key={key}
            type='button'
            onClick={e => {
              setTab(key);
              e.target.blur();
            }}
            className={`rounded-lg px-4 py-2 text-sm font-medium outline-none transition-colors focus:outline-none ${
              tab === key ? 'bg-blue-50 text-blue-700' : 'text-slate-600 hover:bg-slate-50'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {tab === 'panel' ? <SmsKpis /> : <SmsMasivo />}
    </div>
  );
};

export default SmsSettings;
